import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldReportType = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.report_type_id,
    name: item?.report_type_name,
    description: item?.report_type_description,
    reporter: '',
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
    riskOwnerIs: item?.is_report_ownself,
    reportConfidential: item?.is_confidential,
    setupReporter: item?.is_allreporter,
    setupReceiver: item?.is_rmreceiver,
    riskTeamReporter: item?.is_skiptoapprove,
    companies: item?.company,
    groups: item?.group,
    bus: item?.business_unit,
    divisions: item?.division,
    departments: item?.department,
    sections: item?.section,
  }
}

export const getReportTypeListApi = ({
  company_id,
  group_id,
  bu_id,
  division_id,
  department_id,
  section_id,
  param,
  is_active,
  page,
  size,
}) => {
  const params = removeEmpty({
    company_id,
    group_id,
    bu_id,
    division_id,
    department_id,
    section_id,
    param,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: '/api/v1/report_type/',
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldReportType),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createReportTypeApi = ({
  report_type_name,
  report_type_description,
  is_active,
  is_report_ownself,
  is_confidential,
  is_skiptoapprove,
  is_allreporter,
  is_rmreceiver,
  company,
  group,
  business_unit,
  division,
  department,
  section,
}) => {
  const data = {
    report_type_name,
    report_type_description,
    is_active,
    is_report_ownself,
    is_confidential,
    is_skiptoapprove,
    is_allreporter,
    is_rmreceiver,
    company,
    group,
    business_unit,
    division,
    department,
    section,
  }

  const config = {
    method: 'post',
    url: '/api/v1/report_type/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getReportTypeByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/report_type/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: mapFieldReportType(res.data) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteReportTypeByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/report_type/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateReportTypeByIdApi = ({
  id,
  report_type_name,
  report_type_description,
  is_active,
  is_report_ownself,
  is_confidential,
  is_skiptoapprove,
  is_allreporter,
  is_rmreceiver,
  company,
  group,
  business_unit,
  division,
  department,
  section,
}) => {
  const data = {
    report_type_name,
    report_type_description,
    is_active,
    is_report_ownself,
    is_confidential,
    is_skiptoapprove,
    is_allreporter,
    is_rmreceiver,
    company,
    group,
    business_unit,
    division,
    department,
    section,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/report_type/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
